<template>
  <div :title="$t(title)">
    <tvPlayIcon v-if="vod"/>
    <CalendarWithClockIcon v-if="upcoming"/>
    <div class="live" v-if="live">
      {{ $t('Live') }}
    </div>
  </div>
</template>

<script>
import tvPlayIcon from '../../../assets/img/tvPlayIcon';
import {STREAM_STATUS} from '@/const';
import CalendarWithClockIcon from '../../../assets/img/CalendarWithClockIcon';

export default {
  name: 'EventStatus',
  components: {
    CalendarWithClockIcon,
    tvPlayIcon,
  },
  props: {
    event: Object,
  },
  computed: {
    live() {
      return STREAM_STATUS.live === this.event.stream_status;
    },
    vod() {
      return STREAM_STATUS.vod === this.event.stream_status;
    },
    upcoming() {
      return STREAM_STATUS.upcoming === this.event.stream_status;
    },
    title() {
      switch (this.event.stream_status) {
        case STREAM_STATUS.live:
          return 'Live';
        case STREAM_STATUS.vod:
          return 'vod';
        default:
          return 'Coming';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.live {
  font-size: .7rem;
  font-weight: 600;
  background-color: var(--theme-error);
  color: var(--settings-body-background);
  padding: 0 .3rem;
  margin-top: .25rem;
  text-transform: lowercase;
}
</style>
